/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ time: NonNullable<unknown> }} Mobile_Chapter_Time_RemainingInputs */

const en_mobile_chapter_time_remaining = /** @type {(inputs: Mobile_Chapter_Time_RemainingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Time remaining ${i?.time}`)
};

const es_mobile_chapter_time_remaining = /** @type {(inputs: Mobile_Chapter_Time_RemainingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tiempo restante ${i?.time}`)
};

/**
* | output |
* | --- |
* | "Time remaining {time}" |
*
* @param {Mobile_Chapter_Time_RemainingInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_chapter_time_remaining = /** @type {((inputs: Mobile_Chapter_Time_RemainingInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Chapter_Time_RemainingInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_chapter_time_remaining(inputs)
	return en_mobile_chapter_time_remaining(inputs)
});